// src/pages/About.jsx
import React from "react";
import CustomNavbar from "../components/CustomNavbar";


import Footer from "../components/Footer";
import ServiceBanner from "../components/ServiceBanner";
import ServicesPageSection from "../components/ServicesPageSection";
import StatsSection from "../components/StatsSection";


const Service = () => {
  return (
    <>
      <CustomNavbar />
     <ServiceBanner/>
     <ServicesPageSection/>
     <StatsSection/>
      <Footer />
    </>
  );
};

export default Service;
